import React from 'react';

export const LIVELLI = {
  certo: { testo: 'Certo', stile: 'bg-red-600 text-white' },
  probabile: { testo: 'Probabile', stile: 'bg-orange-500 text-white' },
  possibile: { testo: 'Da verificare', stile: 'bg-amber-100 text-amber-800' },
  escluso: { testo: 'Escluso', stile: 'bg-gray-200 text-gray-700' },
};

export const BadgeLivello = ({ livello, testid }) => (
  <span className={`px-2 py-0.5 rounded-full text-[11px] font-bold ${LIVELLI[livello]?.stile || ''}`} data-testid={testid}>
    {LIVELLI[livello]?.testo || livello}
  </span>
);

export const preparazioni = (n) => `${n} ${n === 1 ? 'preparazione bloccata' : 'preparazioni bloccate'}`;

// Etichetta di una preparazione bloccata da un richiamo (elenco lotti)
export const BadgeRichiamo = ({ lotto }) => (lotto?.richiamo ? (
  <span className="inline-block px-1.5 py-0.5 rounded bg-red-600 text-white text-[10px] font-bold ml-1 align-middle"
    title={`Richiamo n. ${lotto.richiamo.numero}`} data-testid={`lotto-richiamato-${lotto.id}`}>
    RICHIAMATO
  </span>
) : null);
